import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[cardNumber]',
  standalone: true
})
export class CardNumberDirective {

  constructor() { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: any) {
    const key = event.key;
    const isNumber = /^[0-9]$/.test(key);

    if (!(isNumber || ['ArrowLeft', 'ArrowRight', 'Backspace'].includes(key))) {
      event.preventDefault();
    }

  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData?.getData('text');
    if (pastedText && !/^\d+$/.test(pastedText)) {
      event.preventDefault();
    }
  }

}
